import Text from 'components/Text/Text';
import React from 'react';
import { Checkbox, Form } from 'antd';

interface IProps {
	toggleIsRestricted: () => void;
	isRestricted: boolean;
}

export const IsRestrictedCheckBox: React.FC<IProps> = React.memo(({ toggleIsRestricted, isRestricted }) => (
	<Form.Item name="isRestricted" data-test="IsRestrictedCheckBox">
		<Checkbox checked={isRestricted} onChange={toggleIsRestricted}>
			<Text translationNameSpace="form" translationKey="isRestrictedLabel" asFragment={true} />
		</Checkbox>
	</Form.Item>
));
